import { defineStore } from 'pinia'
import { UILanguage } from '@/enums.ts'

export const useRootStore = defineStore('root', () => {
  const uiLanguages = [
    { value: UILanguage.English, text: 'English', },
    { value: UILanguage.Estonian, text: 'Eesti' },
    { value: UILanguage.Russian, text: 'Русский' },
    { value: UILanguage.Spanish, text: 'Español' },
  ]
  const uiDefaultLanguage = UILanguage.English
  // const = 'rueee' // TODO: Move to user store

  return {
    uiLanguages,
    uiDefaultLanguage
  }
})
